<app-alert
  *ngIf="error"
  level="error"
  message="There was an error while attempting to update the call. Please try again."
  [dismissDelay]="5000"
  (dismissed)="dismissError()">
</app-alert>

<h2>Add Call to Existing Business</h2>
<p>Please search and choose the business you would like to add this phone number to.</p>

<p><span class="tw-font-bold">Selected Business: </span>{{ selectedBusiness ? selectedBusiness.name : 'none' }}</p>

<div class="tw-pb-3">
  <app-borrower-search-input (borrower)="setSelectedBorrower($event)"></app-borrower-search-input>
</div>

<div class="tw-text-right">
  <span class="tw-mr-2">
    <button mat-button (click)="close()">Cancel</button>
  </span>
  <button
    mat-flat-button
    color="primary"
    (click)="updateCall()"
    [disabled]="loading || !selectedBusiness">
    <span *ngIf="!loading">Update Call</span>
    <mat-spinner
      *ngIf="loading"
      diameter="24"
      style="display: inline-block; height: 24px; width: 24px;">
    </mat-spinner>
  </button>
</div>
